module.exports = __webpack_public_path__ + "static/background-shape.bc51846a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/background-shape.png
// module id = ./src/images/background-shape.png
// module chunks = 35783957827783 153935816800649